// utils/windowId.ts
export const getWindowId = () => {
  let windowId = sessionStorage.getItem("windowId");
  if (!windowId) {
    //windowId = crypto.randomUUID(); // o usa uuid()
    //sessionStorage.setItem("windowId", windowId);
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hour = String(now.getUTCHours()).padStart(2, '0');
    const minute = String(now.getUTCMinutes()).padStart(2, '0');
    const second = String(now.getUTCSeconds()).padStart(2, '0');

    // Generar número aleatorio de 4 dígitos (entre 1000 y 9999)
    const random = Math.floor(1000 + Math.random() * 9000);

    // Construir el ID
    windowId = `${year}${month}${day}_${hour}${minute}${second}_${random}`;

    sessionStorage.setItem("windowId", windowId);
  }
  return windowId;
}
